import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import Splash from '../../components/alerts/Splash';
import { gEnums } from '../../enums/globalEnums';
import { startConfirmationTypes, startTypes } from '../reducers/StartReducer';
import { ParentContext } from './ParentContext';
import { useStyles } from './useHelpers/useStyles';

export const SplashContext = createContext();

const SplashContextProvider = (props) => {

  const { setStyleAndClass } = useStyles()

  const parentContext = useContext(ParentContext);
  const { states, handlers } = parentContext ?? {}
  const { appSettings_state, currentSettings_state } = states
  const { appSettings_handlers, start_handlers } = handlers
  const { handleAmmend_startDimmer } = start_handlers ?? {}

  // appSettingsContext 
  let { showSplash } = appSettings_state ?? {}

  // pageContext 
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { splashScreen } = aps_global ?? {}
  let { splashScreenDelay } = splashScreen ?? {}

  if (!splashScreenDelay) { splashScreenDelay = 2 }

  const styleAndClass = setStyleAndClass({ item: gEnums.projectStyles.splashScreen })


  if (!styleAndClass.style) { styleAndClass.style = {} }
  if (!styleAndClass.style.backgroundColor) { styleAndClass.style.backgroundColor = 'black' }
  if (!styleAndClass.style.color) { styleAndClass.style.color = 'white' }

  const initSecs = showSplash ? splashScreenDelay : 0
  const [timeLeft, setTimeLeft] = useState(initSecs);

  // const requiredConfirmations = Object.values(startConfirmationTypes);

  // const isAppReady = useMemo(() => {
  //   return _.every(requiredConfirmations, key =>
  //     startConfirmations?.[key] === true
  //   );
  // }, [startConfirmations]);

  useEffect(() => {
    if (!timeLeft && showSplash) {
      appSettings_handlers.handleHideSplash()
      return;
    } else {
      if (showSplash) {
        handleAmmend_startDimmer && handleAmmend_startDimmer(startTypes.finish, 'SplashContextProvider')
        const intervalId = setInterval(() => {
          setTimeLeft(timeLeft - 1);
        }, 1000);
        return () => clearInterval(intervalId);
      }
    }
    // eslint-disable-next-line
  }, [timeLeft, showSplash]);

  return (
    <React.Fragment>
      <Splash styleAndClass={styleAndClass} show={showSplash} />
      {!showSplash && <SplashContext.Provider value={{ ok: true }}>
        {props.children}
      </SplashContext.Provider>
      }
    </React.Fragment>
  )
}

export default SplashContextProvider